import OpenHeader from '../OpenHeader'
import DefaultHeader from '../DefaultHeader'
import ChevronDownIcon from '@ui-components-3/icons/lib/solid/ChevronDown'
import ChevronUpIcon from '@ui-components-3/icons/lib/solid/ChevronUp'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import Loading from '@ui-components-3/ui/lib/components/Loading'

type HeaderContainerProps = {
  isOpen: boolean
  toggleIsOpen: () => void
  fullName: string
  age: string | number
  medicationName: string
  medicationUnit: string
  medicationDirections: string
  quantity: string
  refills: string
  daysSupply: number
  address: string
  state: string
  phone: string
  gender: string
  dob: string
  height: string
  weight: string
  isReady?: boolean
}

const HeaderContainer = ({
  isOpen,
  toggleIsOpen,
  fullName,
  age,
  medicationName,
  medicationUnit,
  medicationDirections,
  quantity,
  refills,
  daysSupply,
  address,
  state,
  phone,
  gender,
  dob,
  height,
  weight,
  isReady = true,
}: HeaderContainerProps) => {
  const title = `${fullName}, ${age}`

  const ArrowIcon = isOpen ? ChevronUpIcon : ChevronDownIcon

  return (
    <div>
      <div
        className={classNames(
          'flex flex-col sm:flex-row justify-between gap-x-3 gap-y-2 items-start',
          !isReady && !isOpen && 'sm:items-center',
        )}
      >
        {isOpen ? (
          <OpenHeader
            title={title}
            address={address}
            state={state}
            phone={phone}
            gender={gender}
            dob={dob}
            height={height}
            weight={weight}
          />
        ) : (
          <DefaultHeader
            title={title}
            medicationName={medicationName}
            medicationUnit={medicationUnit}
            medicationDirections={medicationDirections}
            quantity={quantity}
            refills={refills}
            daysSupply={daysSupply}
            isReady={isReady}
          />
        )}

        <button type="button" className="btn-small btn-primary-outlined shrink-0" onClick={toggleIsOpen}>
          {isOpen ? 'Hide details' : 'View details'}
          <ArrowIcon aria-hidden="true" className="!mr-0" />
        </button>
      </div>
      {!isReady && <Loading shown className="w-full" />}
    </div>
  )
}

export default HeaderContainer
